const loadingLabel = "Φόρτωση";
const elGR = {
  loadingLabel
};
export {
  elGR as default,
  loadingLabel
};
